<div class="card-body">
    <div id="apex-grouped-chart"></div>
</div>